import { ADD_GROWTHBOOK_EXPERIMENT } from '../../constants/growthbookExperiments';
import type { GrowthbookExperiment } from '../../reducers/app/growthbookExperiments';

export const addGrowthbookExperiment = (payload: GrowthbookExperiment) => ({
  type: ADD_GROWTHBOOK_EXPERIMENT,
  payload,
});
